import React from 'react';
import {
    Layout,
    ResourceItem,
    Banner,
    FooterHelp,
    Link,
    Tabs,
    Card,
    Button,
    Stack
} from '@shopify/polaris';
import { withRouter } from "react-router";
import DashboardProductsTab from './DashboardProductsTab';
import DashboardCustomerTab from './DashboardCustomerTab';
import DashboardоOrdersTab from './DashboardOrdersTab';
import RequiredDataProgress from '../components/shared/RequiredDataProgress';
import FileSaver from 'file-saver';
import { AppContext } from '../common/AppContext';
// import { TagSuggestionsComponent } from './TagSuggestionsComponent';

class DashboardComponent extends React.Component {

    state = {
        selectedTag: null,
        selectedTagProducts: [],
        selectedTabIndex: 0,
        taggedResources: [],
    };

    render() {

        const freePlan = this.context.tierName === "Free";
        const appContext = this.context;

        let activeTab = null;

        if (this.state.selectedTabIndex === 0) {
            activeTab = <DashboardProductsTab
                tags={this.props.tags}
                productCount={this.props.productCount} />
        }

        if (this.state.selectedTabIndex === 1) {
            activeTab = <DashboardCustomerTab
                tags={this.props.customerTags}
                customerCount={this.props.customerCount} />
        }

        if (this.state.selectedTabIndex === 2) {
            activeTab = <DashboardоOrdersTab
                tags={this.props.orderTags}
                orderCount={this.props.orderCount} />
        }

        const tabs = [
            {
                id: 'tags-products',
                content: 'Product Tags',
                accessibilityLabel: 'Products Tags',
                panelID: 'tags-products-content-1',
            },
            {
                id: 'tags-customers',
                content: 'Customer Tags',
                accessibilityLabel: 'Customer Tags',
                panelID: 'tags-customers-content-1',
            },
            {
                id: 'tags-orders',
                content: 'Order Tags',
                accessibilityLabel: 'Order Tags',
                panelID: 'tags-orders-content-1',
            }
        ];

        let requiredDataSection = null;

        if (!appContext.isInit) {
            requiredDataSection = <Layout.Section>
                <RequiredDataProgress onDone={this.props.onRefreshData} />
            </Layout.Section>
        }

        let topLayout = <Layout>
            {freePlan && <Layout.Section fullWidth>
                <Banner
                    title="Subscribe for a plan"
                    status="info"
                    action={{ "content": "Subscribe", url: "/change-plan" }}
                    onDismiss={() => { }}
                >
                    <p>All subscription plans now have unlimited operations and all features enabled starting as low as $5/month.</p>
                    <p>Subscribe to support us so that we can continue to improve the app.</p>
                </Banner>
            </Layout.Section>}
            {requiredDataSection}
            {/* <Layout.Section fullWidth>
                <MediaCard
                    title="Introducing Tag Explorer"
                    primaryAction={{
                        content: 'Learn More',
                        onAction: () => { this.redirectToUrl("https://taggenieapp.com/posts/introducing-tag-explorer-for-shopify/") },
                    }}
                    description={`Tag Explorer for Shopify is the regular Shopify Admin on steroids where you can bulk edit product tags in full screen mode with highly configurable UI`}
                >
                    <VideoThumbnail
                        // videoLength={624}
                        thumbnailUrl="https://taggenie.azureedge.net/images/tag-explorer-cover-small.jpg"
                        onClick={() => this.redirectToUrl("https://taggenieapp.com/posts/introducing-tag-explorer-for-shopify/")}
                    />
                </MediaCard>
            </Layout.Section> */}
            <Layout.Section>
                <Card title="Want to bulk edit tags?" sectioned>
                    <p>Tag Genie is one of the best ways to edit Shopify tags. <b>Tag Explorer</b> is a new an immersive way to bulk edit tags. <b>Bulk Operations</b> provide purpose-built UI for common bulk editing scenarios.</p>
                    <br />
                    <Stack alignment="center" distribution="leading">
                        <Stack.Item>
                            <Button primary
                                onClick={() => this.props.history.push("/explorer")}>Check out Tag Explorer</Button>
                        </Stack.Item>
                        <Stack.Item>
                            <Button primary
                                onClick={() => this.props.history.push("/operations/new")}>Check out Bulk Operations</Button>
                        </Stack.Item>
                    </Stack>
                </Card>
                <Card title="Want to automate tags?" sectioned>
                    <p>To automate Shopify tags use one of our Tag Rules which make tag automation easy as pie. Take a look at the list of the rules.</p>
                    <br />
                    <Button primary
                        onClick={() => this.props.history.push("/tag-rules/list")}>Checkout Tag Rules</Button>
                    <br />
                </Card>
            </Layout.Section>
            <Layout.Section oneThird>
                <Card title="Need help? Looking for a feature? Contact us!" sectioned>
                    <p>If you need help or you are looking for a feature don't hesitate to contact us below! Our support team will be happy to help you!</p>
                    <br />
                    <div className="chatwithus-button">
                        <Button onClick={() => { window.$crisp.push(["do", "chat:open"]); }}>Chat with us</Button>
                    </div>
                    <br />
                    <div className="whatsapp-button">
                        <Button onClick={() => { window.open("https://wa.me/359887660414", '_blank') }}>Chat with us on WhatsApp</Button>
                    </div>
                    <br />
                    <div>
                        <Button onClick={() => { window.open("mailto:support@taggenieapp.com", '_blank') }}>Send us and email</Button>
                    </div>
                </Card>
            </Layout.Section>
        </Layout>


        let footerLayout = <Layout>
            <Layout.Section fullWidth>
            </Layout.Section>
            <FooterHelp>
                Learn more about{' '}
                <Link url="/plans">action credits</Link>
            </FooterHelp>
        </Layout>

        return <div>
            {topLayout}
            <br />
            {/* {modal} */}
            {/* <TagSuggestionsComponent /> */}
            <br />
            <Tabs tabs={tabs} fitted selected={this.state.selectedTabIndex} onSelect={this.handleTabChange}>
                {activeTab}
            </Tabs>
            {footerLayout}
        </div>
    }

    redirectToUrl = (url) => {
        window.open(url, '_blank');
    }

    renderProductItem = (item) => {
        const { id, productName } = item;

        return (
            <ResourceItem id={id} url={null} onClick={(e) => this.handleProductItemClick(e, item)}>
                <span>{productName}</span>
            </ResourceItem>
        );
    }

    handleModalClose = () => {
        this.setState({ "selectedTag": null });
    }

    handleTabChange = (selectedTabIndex) => {
        this.setState({ "selectedTabIndex": selectedTabIndex });
    }

    handleProductItemClick = (e, item) => {
        window.open("url", '_blank');
    }

    handleProductTagSelectedChange = (selectedTags) => {

        if (selectedTags.length <= 0) {
            return;
        }

        this.setState({ "selectedTag": selectedTags[0] });
    }

    handleCustomerTagSelectedChange = (selectedTags) => {

        if (selectedTags.length <= 0) {
            return;
        }

        this.setState({ "selectedTag": selectedTags[0] });
    }

    onEditTags = () => {
        this.props.onCreateNewOperation();
    }

    onExportTags = () => {
        let fileBlob = this.createCsv();
        FileSaver.saveAs(fileBlob, "tags.csv");
    }

    createCsv = () => {
        let csv = ''
        let row = ''
        let headers = ''
        headers = headers.concat('tag_name');
        csv = csv.concat(headers);
        this.props.tags.map(_ => _.tagName).sort().forEach(tag => {
            row = ''
            row = row.concat("\n", tag);
            csv = csv.concat(row)
        });

        return new Blob([csv], { type: 'application/csv;charset=utf-8' })
    }

    onBackClicked = async () => {
        this.setState({ selectedTag: null, queryValue: null });
    }

    componentDidMount() {
    }
}

DashboardComponent.contextType = AppContext;

export default withRouter(DashboardComponent);